
import { Component, Vue, Prop, Ref } from 'vue-property-decorator'
import ImageBase from '@/components/atoms/ImageBase.vue'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import FloatPanel, { POSITION_SET } from '@/components/molecules/FloatPanel.vue'
import PanelFrame from '@/components/molecules/PanelFrame.vue'

/**
 * ユーザ編集フロートメニュー
 */
@Component({
  components: {
    ImageBase,
    ButtonBase,
    FloatPanel,
    PanelFrame,
  },
})
export default class MenuEditUser extends Vue {
  /** フロートメニュー部 */
  @Ref()
  floatPanel!: FloatPanel

  /** 削除ボタン押下時のイベント */
  @Prop()
  private eventClickDeleteButton!: (userId: number) => void

  /** ユーザデータ編集ボタン押下時のイベント */
  @Prop()
  private eventClickEditUserDataButton!: (userId: number) => void

  /** パスワード編集ボタン押下時のイベント */
  @Prop()
  private eventClickEditPasswordButton!: (userId: number) => void

  /** 操作対象のユーザID */
  private userId = 0

  /** クローズ時の処理 */
  private eventClosed: (() => void) | undefined = undefined

  /**
   * 表示
   *
   * @param target 表示位置の基準にするDOM要素
   * @param userId 操作対象ユーザID
   * @param parentElement オプション情報表示エリアの基準となる親DOM要素
   */
  public async show(target: HTMLElement, userId: number, parentElement?: HTMLElement): Promise<void> {
    this.userId = userId
    await this.floatPanel.show(target, POSITION_SET.LEFT_DOWN, parentElement)
  }

  /**
   * 削除ボタン押下時処理
   */
  private eventDelete(): void {
    this.floatPanel.close()
    this.eventClickDeleteButton(this.userId)
  }

  /**
   * 編集ボタン押下時処理
   */
  private eventEditUser(): void {
    this.floatPanel.close()
    this.eventClickEditUserDataButton(this.userId)
  }

  /**
   * パスワード変更ボタン押下時処理
   */
  private eventEditPassword(): void {
    this.floatPanel.close()
    this.eventClickEditPasswordButton(this.userId)
  }

  /**
   * クローズ時処理
   */
  private closeEvent(): void {
    // 設定されている場合のみ実行
    if (this.eventClosed) {
      this.eventClosed()
    }
  }
}
